<template>
    <div
        id="app"
        class="app"
        :class="[
            {
                phone: systemInfo.screenView === 'phone',
                pad: systemInfo.screenView === 'pad',
                desktop: systemInfo.screenView === 'desktop',
            },
        ]"
    >
        <!-- <transition :name="transitionName">
            <keep-alive>
                <router-view class="view"></router-view>
            </keep-alive>
        </transition> -->

        <router-view class="view"></router-view>
    </div>
</template>

<script>
const firstLaunch = true;
export default {
    data() {
        return {
            transitionName: '',
            systemInfo: null,
            darkmode: false,
        };
    },

    async created() {
        const systemInfo = {
            versions: (function () {
                const u = navigator.userAgent;
                    const app = navigator.appVersion;
                return {
                    trident: u.indexOf('Trident') > -1, // IE内核
                    presto: u.indexOf('Presto') > -1, // opera内核
                    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
                    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
                    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
                    iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
                    iPhoneX:
                        u.indexOf('iPhone') > -1
                        && window.screen.width === 375
                        && window.screen.height === 812, // 是否为 iPhone X
                    iPad: u.indexOf('iPad') > -1, // 是否iPad
                    iPadPro:
                        u.indexOf('iPad') > -1
                        && ((window.screen.width === 1366 && window.screen.height === 1024)
                            || (window.screen.width === 1024 && window.screen.height === 1366)), // 是否iPad Pro
                    webApp: u.indexOf('Safari') == -1, // 是否web应该程序，没有头部与底部
                };
            }()),
            language: (navigator.browserLanguage || navigator.language).toLowerCase(),
            standalone: navigator.standalone,
            // darkmode: window.matchMedia('(prefers-color-scheme: dark)').matches || false,
            darkmode: false,
        };

        let screenView = '';
        if (document.documentElement.clientWidth <= 768) {
            screenView = 'phone';
        } else if (
            document.documentElement.clientWidth > 768
            && document.documentElement.clientWidth <= 1280
        ) {
            screenView = 'pad';
        } else {
            screenView = 'desktop';
        }

        // this.setSystemInfo({ ...systemInfo, screenView });

        this.systemInfo = { ...systemInfo, screenView };
        // this.setSystemInfo(systemInfo);

        // if (firstLaunch) {
        //     await this.init();
        // }
        // firstLaunch = false;

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                let screenView = '';
                if (document.documentElement.clientWidth <= 768) {
                    screenView = 'phone';
                } else if (
                    document.documentElement.clientWidth > 768
                    && document.documentElement.clientWidth <= 1280
                ) {
                    screenView = 'pad';
                } else {
                    screenView = 'desktop';
                }
                this.systemInfo = { ...systemInfo, screenView };

                console.log('~~~~~ resize this.systemInfo', this.systemInfo);

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },

    mounted() {},

    methods: {},

    watch: {
        $route(to, from) {
            if (to.meta.index > from.meta.index) {
                this.transitionName = 'fade-left';
            } else if (to.meta.index < from.meta.index) {
                this.transitionName = 'fade-right';
            } else {
                this.transitionName = '';
            }
        },
    },
};
</script>

<style lang="scss">
@import '~@/stylesheets/all';
@import '/static/iconfont/iconfont.css';

.swiper-pagination111,
.swiper-pagination333 {
    .swiper-pagination-bullet {
        transition: all 0.24s ease;

        width: 8px;
        height: 8px;
        border-radius: 4px;
        margin-right: 8px !important;
        &:last-child {
            margin-right: 0 !important;
        }
    }

    .swiper-pagination-bullet-active {
        width: 24px;
        background: rgba(255, 51, 85, 1) !important;
    }
}

.swiper-pagination222 {
    .swiper-pagination-bullet {
        transition: all 0.24s ease;

        width: 8px;
        height: 8px;
        border-radius: 4px;
        margin-right: 8px !important;
        &:last-child {
            margin-right: 0 !important;
        }
    }

    .swiper-pagination-bullet-active {
        width: 24px;
        background: #ffffff !important;
    }
}

.phone {
    .h1 {
        font-size: 24px;
    }

    .t3 {
        font-size: 16px;
    }
}
</style>
